<template>
  <div class="canvas">
    <div class="biaoti">历史审批记录</div>
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item label="到访时间">
        <el-date-picker
          v-model="searchForm.visitTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item style="float: right;">
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="reset">重置</el-button>
        <el-button type="success" @click="exportRecords">导出记录</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="pagedRecords" style="width: 100%">
      <!-- <el-table-column prop="id" label="编号" width="100"></el-table-column> -->
      <el-table-column prop="name" label="访客名字" width="180"></el-table-column>
      <el-table-column prop="phone" label="访客手机号" width="180"></el-table-column>
      <el-table-column prop="qiyeName" label="来访单位" width="180"></el-table-column>
      <el-table-column prop="beifangName" label="接访人名字" width="180"></el-table-column>
      <el-table-column prop="daofangNumber" label="到访人数" width="180"></el-table-column>
      <el-table-column prop="readTime" label="到访时间" width="180"></el-table-column>
      <el-table-column label="操作" width="180">
        <template #default="scope">
          <el-button type="text" @click="viewDetails(scope.row)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      background
      layout="prev, pager, next"
      :total="totalRecords"
      :page-size="pageSize"
      :current-page="currentPage"
      @current-change="handlePageChange">
    </el-pagination>

    <!-- 审批管理抽屉 -->
    <el-drawer
      title="审批记录详情"
      :visible.sync="drawerVisible"
      direction="rtl"
      size="50%">
      <el-form label-width="120px" label-position="left">
        <!-- <el-form-item label="编号" style="padding-left: 20px">
          <el-input v-model="currentRecord.id" disabled></el-input>
        </el-form-item> -->
        <el-form-item label="访客名字" style="padding-left: 20px">
          <el-input v-model="currentRecord.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="访客手机号" style="padding-left: 20px">
          <el-input v-model="currentRecord.phone" disabled></el-input>
        </el-form-item>
        <el-form-item label="来访单位" style="padding-left: 20px">
          <el-input v-model="currentRecord.qiyeName" disabled></el-input>
        </el-form-item>
        <el-form-item label="接访人名字" style="padding-left: 20px">
          <el-input v-model="currentRecord.beifangName" disabled></el-input>
        </el-form-item>
        <el-form-item label="填写时间" style="padding-left: 20px">
          <el-input v-model="currentRecord.writeTime" disabled></el-input>
        </el-form-item>
        <el-form-item label="到访时间" style="padding-left: 20px">
          <el-input v-model="currentRecord.readTime" disabled></el-input>
        </el-form-item>
        <el-form-item label="到访事由" style="padding-left: 20px">
          <el-input v-model="currentRecord.reason" disabled></el-input>
        </el-form-item>
        <el-form-item label="到访人数" style="padding-left: 20px">
          <el-input v-model="currentRecord.daofangNumber" disabled></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="drawerVisible = false">关闭</el-button>
      </span>
    </el-drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchForm: {
        visitTime: []
      },
      allRecords: [], // 所有数据
      pagedRecords: [], // 当前页的数据
      totalRecords: 0, // 总记录数
      pageSize: 10, // 每页显示的记录数
      currentPage: 1, // 当前页码
      drawerVisible: false, // 抽屉可见性
      currentRecord: {} // 当前记录
    };
  },
  methods: {
    // 根据条件查询记录
    search() {
      this.currentPage = 1; // 查询时重置到第一页
      this.fetchRecords();
    },
    // 获取记录数据
    fetchRecords() {
      const params = {};

      // 如果有时间范围，则添加到参数中
      if (this.searchForm.visitTime && this.searchForm.visitTime.length === 2) {
        const formatTime = (date) => {
          const year = date.getFullYear();
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const day = date.getDate().toString().padStart(2, '0');
          const hours = date.getHours().toString().padStart(2, '0');
          const minutes = date.getMinutes().toString().padStart(2, '0');
          const seconds = date.getSeconds().toString().padStart(2, '0');
          return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };

        params.startTime = formatTime(this.searchForm.visitTime[0]);
        params.endTime = formatTime(this.searchForm.visitTime[1]);
      }

      this.$axios.post('/api/get_all_shenpiAllow_day', params)
        .then(response => {
          this.allRecords = response.data.data.map(item => {
            // 替换 readTime 字段中的 T 为空格
            if (item.readTime) {
              item.readTime = item.readTime.replace('T', ' ');
              item.writeTime = item.writeTime.replace('T', ' ');
            }
            return item;
          });
          this.totalRecords = this.allRecords.length;
          // console.log(this.totalRecords)
          this.updatePagedRecords();
        })
        .catch(error => {
          console.error('Error fetching records:', error);
        });
    },
    // 更新当前页的数据
    updatePagedRecords() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      this.pagedRecords = this.allRecords.slice(start, end);
    },
    // 重置表单
    reset() {
      Object.assign(this.searchForm, {
        visitTime: []
      });
      this.allRecords = [];
      this.totalRecords = 0;
      this.currentPage = 1;
      this.fetchRecords(); // 重新获取所有记录
    },
    // 查看详情
    viewDetails(row) {
      this.currentRecord = Object.assign({}, row);
      this.drawerVisible = true;
    },
    // 处理分页变化
    handlePageChange(page) {
      this.currentPage = page;
      this.updatePagedRecords();
    },
    // 导出记录
    exportRecords() {
      const params = {
        visitTime: this.searchForm.visitTime || undefined
      };
      console.log(params)

      // 格式化时间
      const formatTime = (date) => {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      };

      const startTimeFormatted = this.searchForm.visitTime.length > 0 ? formatTime(this.searchForm.visitTime[0]) : '';
      const endTimeFormatted = this.searchForm.visitTime.length > 1 ? formatTime(this.searchForm.visitTime[1]) : '';
      const time = {
        startTime: startTimeFormatted,
        endTime: endTimeFormatted
      };

      this.$axios.post('/api/export_records', time, { responseType: 'blob' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', '审批记录.xlsx');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        })
        .catch(error => {
          console.error('Error exporting records:', error);
        });
    },
  },
  mounted() {
    this.fetchRecords(); // 组件挂载时获取记录数据
  }
};
</script>
<style>
.demo-form-inline {
  margin-bottom: 20px;
}
.canvas {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  width: 97%;
  position: relative;
}
.biaoti {
  font-family: 'Georgia', serif;
  color: #4396e5;
  font-size: 30px;
  font-weight: bold;
  padding: 15px;
}
</style>